import styled, { css } from 'styled-components';
import Modal from 'react-modal';

import mixin from '../../_foundations/Mixin';
import Footer from '../Footer';
import Header from '../Header';
import VerticalFlow from '../VerticalFlow';

export const ModalComponent = styled(Modal)`
  position: absolute;
  background: var(--neutral-10);
  outline: none;
  display: grid;
  grid-template:
    [header-start] 'header' auto [header-end]
    [content-start] 'content' 1fr [content-end]
    [footer-start] 'footer' auto [footer-end]
    / 1fr;
  ${mixin.borderRadius()}
  ${mixin.elevation()};
  min-height: 0;
  min-width: 0;
  & > ${Header} {
    grid-area: header;
    padding: 0.25rem 0.75rem;
    padding-left: 1.25rem;
  }
  & > ${VerticalFlow} {
    grid-area: content;
    padding: 1rem 1.25rem;
    min-width: 0;
    min-height: 0;
    overflow: auto;
  }
  & > ${Footer} {
    grid-area: footer;
    padding: 0.5rem 1.25rem;
  }
  max-height: min(90vh, 1000px);
  ${(props) =>
    props.bordered &&
    css`
      & > ${Header} {
        ${mixin.border({ only: 'bottom' })}
      }
      & > ${Footer} {
        ${mixin.border({ only: 'top' })}
      }
    `}
  ${(props) => {
    let width = 'min(600px, 90vw)';
    if (props.size === 'small') {
      width = 'min(400px, 90vw)';
    }
    if (props.size === 'large') {
      width = 'min(800px, 90vw)';
    }
    if (props.size === 'takeover') {
      width = 'min(1500px, 90vw)';
    }
    return css`
      width: ${width};
      ${props.size === 'takeover' && 'height: min(90vh, 1000px);'}
    `;
  }}
`;
